<div class="prose">
  <h3>{{ 'pages.login.title' | translate }}</h3>
  <p class="mb-8">{{ 'pages.login.text' | translate }}</p>
</div>
<form
  class="mb-4 flex flex-col items-start gap-4"
  [formGroup]="form"
  (ngSubmit)="submit()"
>
  <formly-form
    class="w-full"
    [model]="model"
    [fields]="fields"
    [form]="form"
    [options]="options"
  />
  <p class="self-end">
    {{ 'pages.login.forgotPassword.text' | translate }}
    <a
      class="cursor-pointer text-blue-600"
      [routerLink]="['/forgot-password']"
      >{{ 'pages.login.forgotPassword.link' | translate }}</a
    >?
  </p>

  <app-button
    type="primary"
    class="w-full"
    data-test-id="submit-button"
    htmlType="submit"
    [disabled]="form.invalid"
    (trigger)="submit()"
  >
    {{ 'pages.login.submitButton.label' | translate }}
    @if (loading) {
      <svg-icon
        class="animate-spin"
        src="assets/icons/General/loading-01.svg"
      />
    }
  </app-button>
</form>
@if (loginError) {
  <p data-test-id="loginError" class="text-red-600">{{ loginError }}</p>
}
